(() => {
  angular
    .module('app')
    .controller(
      'finance.views.billingAccounts.billingAccountDetail.page',
      BillingAccountDetailController
    );

  BillingAccountDetailController.$inject = [
    '$stateParams',
    '$uibModal',
    'abp.service.finance.billingAccount',
  ];

  function BillingAccountDetailController(
    $stateParams,
    $uibModal,
    billingAccountSvc
  ) {
    const vm = this;

    vm.loading = 0;
    vm.id = $stateParams.id;
    vm.entityType = $stateParams.entityType;
    vm.isHost = App.isHost();

    vm.permissions = {
      regenerateLegacyBillingAccountCode: abp.auth.isGranted(
        'HealthMetrics.Finance.BillingAccounts.RegenerateBillingAccountCode'
      ),
    };

    vm.getBillingAccount = getBillingAccount;
    vm.regenerateLegacyBillingAccountCode = regenerateLegacyBillingAccountCode;
    vm.editLegacyAccountCode = editLegacyAccountCode;
    vm.updateBillingAccountFreezeState = updateBillingAccountFreezeState;

    init();

    function init() {
      getBillingAccount();
    }

    function getBillingAccount() {
      const input = {
        id: vm.id,
      };

      vm.loading += 1;
      billingAccountSvc
      .getBillingAccountDetail(input)
      .success((data) => {
        vm.name = data.name;
        vm.accountType = data.type;
        vm.legacyAccountCode = data.legacyAccountCode;
        vm.accountCode = data.accountCode;
        vm.tenancyCode = data.businessIdentifierCode;
        vm.accountOwner = data.accountOwner;
        vm.countryCode = data.countryCode;
        vm.isFrozen = data.isFrozen;

        vm.bankAccounts = data.bankAccounts;
        vm.taxIdentifiers = data.taxIdentifiers;
        vm.billingAddress = data.billingAddress;
      });
      vm.loading -= 1;
    }

    function regenerateLegacyBillingAccountCode() {
      abp.message.confirm(
        App.localize('RegenerateNewAccountBillingCodeConfirmation'),
        App.localize('AreYouSure'),
        (d) => {
          if (d) {
            vm.loading += 1;
            billingAccountSvc
              .getNewBillingAccountCode({
                id: vm.id,
              })
              .success((data) => {
                vm.legacyAccountCode = data;
              })
              .finally(() => {
                vm.loading -= 1;
              });
          }
        }
      );
    }

    function editLegacyAccountCode() {
      $uibModal
      .open({
        templateUrl: require('./editAccountCodeModal/editAccountCode.modal.html'),
        controller: 'finance.views.billingAccounts.editAccountCodeModal as vm',
        backdrop: 'static',
        resolve: {
          billingAccount() {
            return {
              id: vm.id,
              legacyAccountCode: vm.legacyAccountCode
            };
          },
        },
      })
      .result.then((newAccountCode) => {
        if (newAccountCode)
          vm.legacyAccountCode = newAccountCode;
      });
    }

    function updateBillingAccountFreezeState() {
      vm.loading += 1;
      billingAccountSvc
      .updateBillingAccountFreezeState({
        id: vm.id,
        isFrozen: vm.isFrozen
      })
      .success(() => {
        abp.notify.success(App.localize('SuccessfullyUpdated'));
      })
      .finally(() => {
        vm.loading -= 1;
      });
    }
  }
})();
